<div class="vi-input">
  <vi-ui-label *ngIf="label"
    [for]="id"
    [disabled]="disabled"
    [required]="required"
    [value]="label">
  </vi-ui-label>
  <input [type]="type"
    [id]="id"
    [ngClass]="{error: error, 'with-icon': icon}"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.maxlength]="maxLength"
    [attr.min]="min"
    [attr.max]="max"
    [attr.aria-invalid]="error"
    [attr.aria-required]="required"
    [attr.aria-errormessage]="errorMessageId"
    [(ngModel)]="value"
    (input)="onChange($event.target.value)"
    viUiDebounce
    [debounceDueTime]="400"
    (debounceEvent)="debounceValueChange($event)"
    [debounceEventNames]="['input']"
    [debounceValue]="value">
  <i *ngIf="icon"
    class="i-vi-{{icon.type}}"></i>
  <span class="error-message"
    [style.visibility]="error ? 'visible' : 'hidden'"
    [id]="errorMessageId"
    role="alert"
    aria-live="assertive">
    {{ errorMessage }}
  </span>
</div>
